import React, { useState } from "react";
import { motion } from "framer-motion";
import { useProjectStore } from "../../../stores/projectStore";
import { MAX_ITEMS_PER_DOCUMENT } from "../../../../../src/shared/constants";
import classNames from "classnames";

export function LoadingButton(props) {
  const { loadAnimationDuration = 6, children, onClick, className, mode, id, ...rest } = props;
  const creatingDocument = useProjectStore((state) => state.creatingDocument);
  const contents = useProjectStore((state) => state.contents);

  const [gradientPercent, setGradientPercent] = useState(100);

  const [hovered, setHovered] = useState(false);

  const startColor = mode === "dark" ? "white" : "var(--primary-cta)";

  const endColor = mode === "dark" ? "var(--grey-3)" : "var(--grey-2)";

  const disabled = creatingDocument || contents.length >= MAX_ITEMS_PER_DOCUMENT;

  return (
    <motion.button
      id={id}
      key={id}
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
      className={classNames(className, { disabled: disabled, hovered: hovered })}
      onClick={() => {
        setGradientPercent(0);

        if (disabled) {
          return;
        }

        if (onClick) {
          onClick();
        }
      }}
      style={
        disabled || hovered
          ? { background: "unset" }
          : {
              background: `linear-gradient(90deg,  ${startColor} ${gradientPercent}%, ${endColor} ${gradientPercent}%)`,
            }
      }
      animate={
        disabled || hovered
          ? { background: "unset" }
          : {
              background: `linear-gradient(90deg,  ${startColor}  ${gradientPercent}%, ${endColor} ${gradientPercent}%)`,
              transition: {
                duration: gradientPercent === 0 || gradientPercent === 100 ? 0 : loadAnimationDuration,
                ease: "linear",
              },
            }
      }
      onAnimationComplete={() => {
        if (gradientPercent === 0) {
          setGradientPercent(90);
        }
      }}
      disabled={disabled}
      {...rest}
    >
      {children}
    </motion.button>
  );
}
